import moment from 'moment-timezone';

angular.module("events")
    .controller("EventsMenuCtrl", ['$state', 'event', 'LoginService', '$scope', '$stateParams', '$rootScope', 'eventService', '$interval', 'treeService', 'Restangular', 'modalService', '$filter', 'logService', function ($state, event, LoginService, $scope, $stateParams, $rootScope, eventService, $interval, treeService, Restangular, modalService,$filter, logService) {

        event.changesNotSaved = false; //para que aparezca el texto de cambios no guardados
        event.locationChanged = false;

        //Gestión de campos avanzados

        $scope.allOptions = false;
        $scope.toggleIcon = "fas fa-toggle-off";

        $scope.toggleAllOptions = function () {

            if ($scope.allOptions) {
                $scope.allOptions = false;
                // $scope.toggleIcon = "fas fa-toggle-off";
            } else {
                $scope.allOptions = true;
                // $scope.toggleIcon = "fas fa-toggle-on";
            }
        }

        //Comprobamos si la empresa tiene marcado la opción de el artículo 10 para mostrar las opciones en consecuencia
        $scope.article10 = false;
        $scope.article12 = false;
        $scope.public_guest_app_enabled = false;
        Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {

            if (results.article_10 == true) { $scope.article10 = true; }
            if (results.article_12 == true) { $scope.article12 = true; }

            if (results.public_guest_app_enabled == true) { $scope.public_guest_app_enabled = true; }
            // cargamos el menu ahora para poder filtrar los items según los permisos
            $scope.loadMenu();

        }); 

        $scope.selectActFormat = [
            { name: "presencial", translation: $filter('translate')('events.format_presencial') },
            { name: "mixto", translation: $filter('translate')('events.format_mixto') },
            { name: "videoconferencia", translation: $filter('translate')('events.format_videoconferencia') }
        ];

        $scope.showCheckRestricted = true;
        $scope.state = $state; //Controlamos que solo en el estado de edicion general se muestre la edicion de la imagen.

        $scope.allowShowInformation = LoginService.permissionExist("INFORMATION_READ"); //Menu MEMORIA
        //Permisos para los distintos enlaces:
        $scope.allowShowWorkTeam = LoginService.permissionExist("EVENTS_WORK_TEAM_READ");
        $scope.allowShowGuests = LoginService.permissionExist("EVENTS_GUESTS_READ");
        $scope.allowShowTasks = LoginService.permissionExist("EVENTS_TASKS_READ");
        $scope.allowShowProgramAct = LoginService.permissionExist("EVENTS_PROGRAM_ACT_READ");
        $scope.allowShowDiary = LoginService.permissionExist("EVENTS_DIARY_READ");
        $scope.allowShowMaterials = LoginService.permissionExist("EVENTS_MATERIALS_READ");
        $scope.allowShowStaff = LoginService.permissionExist("EVENTS_STAFF_READ");
        $scope.allowShowSpace = LoginService.permissionExist("EVENTS_SPACE_READ");
        $scope.allowShowIndicator = LoginService.permissionExist("EVENTS_INDICATOR_READ");
        $scope.allowShowMailAccount = LoginService.permissionExist("EVENTS_MAIL_ACCOUNT_READ");
        $scope.allowShowBudget = LoginService.permissionExist("EVENTS_BUDGET_READ");
        $scope.allowShowInscriptionsForms = LoginService.permissionExist("INSCRIPTIONS_FORMS_READ");
        $scope.allowShowParkings = LoginService.permissionExist("EVENTS_PARKINGS_READ");
        $scope.allowShowAccreditation = LoginService.permissionExist("EVENTS_ACCREDITATION_READ");
        $scope.allowShowHistoric = LoginService.permissionExist("EVENTS_HISTORIC_READ");
        $scope.allowShowNotifications = LoginService.permissionExist("NOTIFICATIONS_READ");
        $scope.allowShowCMS = LoginService.permissionExist("CMS_CATEGORIES_READ");

        $scope.showEventsMenu = false;
        $scope.sizewidth = 700;
        $scope.regxUrls = /^http(s)?:\/\/.*/;

        $scope.showButtonMenu = true;
        $scope.showEventsMenu = true;

        $scope.$watch(function () {
/*            if (!$rootScope.sizeLg && !$rootScope.sizeMd) {

                $scope.buttontext = "";
                if (!$rootScope.sizeXs) $scope.buttontext = $filter('translate')('events.button_toggle_menu');

            } else {
                $scope.showButtonMenu = true;
                $scope.showEventsMenu = true;
            }*/
            if (typeof (angular.element(".blockDatesSize")[0]) !== 'undefined') $scope.sizewidth = angular.element(".blockDatesSize")[0].offsetWidth;

        });

        $scope.toggleEventsMenu = function () {
            console.log("toggleEventsMenu: " + $scope.showEventsMenu);
            $scope.showEventsMenu = !$scope.showEventsMenu;

        }

        $scope.isPageLoaded = false;

        $scope.loadMenu = function () {
            Restangular.all('Menus').getList({ code: 'EVENT_MENU' }).then(function (results) {
                $scope.menu = results;
                let options = { menu_id: $scope.menu[0].id, _sortBy: "position", _sortDirection: "asc" };
                Restangular.all('MenusItems').getList(options).then(function (results) {

                    // filtramos si tiene la app activada
                    if (!$scope.public_guest_app_enabled) {
                        results = results.filter(m => !m.ui_sref.includes('events.edit.push_notifications'));
                    }

                    let menusItems = [];
                    menusItems = treeService.menuTree(results, null, menusItems);
                    $scope.menusItems = [];
                    let idxParent;
                    let profilePermissions = false;
                    let isSuperAdmin = LoginService.permissionExist("SUPER_ADMIN");
                    if (LoginService.permissionExist("SUPER_ADMIN")) {
                        profilePermissions = true;
                    } else {
                        if (event.logged_event_user != null) {
                            if (event.logged_event_user.event_id == $scope.event.id && event.logged_event_user.FK_events_staff_staff != null) {
                                profilePermissions = true;
                            }
                        }
                    }
                    angular.forEach(menusItems, function (menuItem, idx) {
                        menuItem.editable = 1;
                        if (event.is_restricted_access) {
                            menuItem.visible = 0;
                            menuItem.editable = 0;
                            if(profilePermissions != false) {
                                menuItem.visible = 1;
                                menuItem.editable = 1;
                            }
                        }
                        if (menuItem.parent_menu_item_id == null) {
                            menuItem.childs = [];
                            $scope.menusItems.push(menuItem);
                            idxParent = $scope.menusItems.length - 1;
                        } else {
                            if (angular.isDefined(idxParent)) {
                                $scope.menusItems[idxParent].childs.push(menuItem);
                            }
                        }
                        if(menuItem.ui_sref === "events.edit") {
                            $scope.mainDataEditable = menuItem.editable;
                            $scope.mainDataVisible = menuItem.visible;
                        } else {
                            menuItem.ui_sref = menuItem.ui_sref.replace("})", ", menu_item_id: " + menuItem.id + "})");
                        }
                    });
                });
            });

            // solo podran checkear si es restringido, el responsable que creo el evento o el super administrador
            if (LoginService.get("userId") != event.responsible_id && !LoginService.permissionExist("SUPER_ADMIN")) {
                $scope.showCheckRestricted = false;
            }

        };

        $scope.id = $stateParams.id;
        $scope.is_template = $stateParams.is_template == 'true';
        if (angular.isDefined($stateParams.id) && $stateParams.id != "") {

            $rootScope.is_template = event.is_template;
            $scope.event = event;
            $scope.event.date_from = new Date($scope.event.date_from);
            $scope.event.date_to = new Date($scope.event.date_to);
            $scope.days = Math.round(($scope.event.date_from.getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24));
            $scope.event_ended = ($scope.event.date_to.getTime() - (new Date()).getTime()) < 0;
            $scope.total_guests = 0;
            $scope.guestProgress = 0;
            $scope.total_staff = 0;
            $scope.staffProgress = 0
            $scope.total_tasks = 0;
            $scope.taskProgress = 0;
            $scope.total_materials = 0;
            $scope.materialsProgress = 0;
            $scope.format = "presencial";
            if ($scope.event.reply_deadline) {
               $scope.event.reply_deadline = new Date($scope.event.reply_deadline);
            }

            $scope.progress = 0;

            $scope.calculaTotal = function () {
                if ($scope.event.event_finished) {
                    $scope.progress = 100;
                } else {
                    var total = 0;
                    if ($scope.total_guests > 0) total++;
                    if ($scope.total_staff > 0) total++;
                    if ($scope.total_tasks > 0) total++;
                    if ($scope.total_materials > 0) total++;
                    if (total > 0)
                        $scope.progress = (($scope.guestProgress + $scope.staffProgress + $scope.taskProgress + $scope.materialsProgress) / total).toFixed(0);
                    else
                        $scope.progress = 100;
                }
            }

            //Traducimos el bool para que se muestre en el formulario 

            if ($scope.event.article_10 == true) {
                $scope.event.radio_article_10 = "1";
                $scope.article10 == true
            } else {
                $scope.event.radio_article_10 = "0";
                $scope.article12 == true;
            }  

            $scope.loadInfo = function (event_id) {
                //obtenemos los invitados.
                eventService.getGuests(event_id)
                    .then(function (result) {
                        $scope.guests_pending = result.data.guests_pending;
                        $scope.guests_rejected = result.data.guests_rejected;
                        $scope.guests_confirmed = result.data.guests_confirmed;
                        $scope.guests_delegated = result.data.guests_delegated;
                        $scope.guests_manage_delegate = result.data.guests_manage_delegate;
                        $scope.guests_pending_approval = result.data.guests_pending_approval;
                        $scope.total_guests = result.data.total_guests;
                        $scope.total_guests_original = result.data.total_guests_original;
                        $scope.companion_guests_confirmed = result.data.companion_guests_confirmed;
                        $scope.companion_guests_pending_approval = result.data.companion_guests_pending_approval;
                        $scope.companion_guests_confirmed_nominal = result.data.companion_guests_confirmed_nominal;
                        $scope.companion_guests_confirmed_not_nominal = result.data.companion_guests_confirmed_not_nominal;

                        if ($scope.total_guests > 0)
                            $scope.guestProgress = ($scope.guests_rejected + $scope.guests_confirmed) / $scope.total_guests * 100;
                        else
                            $scope.guestProgress = 0;
                        $scope.calculaTotal();
                    });
                //obtenemos el personal.
                eventService.getStaff(event_id)
                    .then(function (result) {
                        $scope.staff_pending = result.data.staff_pending;
                        $scope.staff_confirmed = result.data.staff_confirmed;
                        $scope.total_staff = result.data.total_staff;
                        if ($scope.total_staff > 0)
                            $scope.staffProgress = $scope.staff_confirmed / $scope.total_staff * 100;
                        else
                            $scope.staffProgress = 0;
                        $scope.calculaTotal();
                    });
                //obtenemos las tareas.
                eventService.getTasks(event_id)
                    .then(function (result) {
                        $scope.tasks_pending = result.data.tasks_pending;
                        $scope.tasks_completed = result.data.tasks_completed;
                        $scope.tasks_canceled = result.data.tasks_canceled;
                        $scope.total_tasks = result.data.total_tasks;
                        if ($scope.total_tasks > 0)
                            $scope.taskProgress = ($scope.tasks_completed + $scope.tasks_canceled) / $scope.total_tasks * 100;
                        else
                            $scope.taskProgress = 0;
                        $scope.calculaTotal();
                    });
                //obtenemos los materiales.
                eventService.getMaterials(event_id)
                    .then(function (result) {
                        $scope.materials_pending = result.data.materials_pending;
                        $scope.materials_confirmed = result.data.materials_confirmed;
                        $scope.total_materials = result.data.total_materials;
                        if ($scope.total_materials > 0)
                            $scope.materialsProgress = $scope.materials_confirmed / $scope.total_materials * 100;
                        else
                            $scope.materialsProgress = 0;
                        $scope.calculaTotal();
                    });
                //obtenemos las inscripciones.
                eventService.getPendingInscriptions(event_id)
                    .then(function (result) {
                        $scope.inscriptions_pending = result.data.pending;
                        $scope.total_inscriptions = result.data.total;
                });
            }
            $scope.loadInfo($stateParams.id);

            let intervalLoadInfo = $interval(function () { $scope.loadInfo($stateParams.id); }, (window as any).CONFIG.time_check_changes_guests);

            let limit_image_height = 0;
            let limit_image_width = 0;
            let loadConfigurationOptions = function () {
                let group_name = "Imágenes";
                Restangular.all('Configurations').getList({ code: "", group_name: group_name }).then(function (response) {
                    let configuration = response;
                    limit_image_width = configuration.filter(function (config) { return config.code == "LIMIT_IMAGE_WIDTH"; }).map(function (config) { return config.value; })[0];
                    limit_image_height = configuration.filter(function (config) { return config.code == "LIMIT_IMAGE_HEIGHT"; }).map(function (config) { return config.value; })[0];
                });
            }

            loadConfigurationOptions(); //Load image since from company_id

            //Cuando salga del events, se destruirá el intervalo.
            $scope.$on("$destroy", function () {
                if (angular.isDefined(intervalLoadInfo)) {
                    $interval.cancel(intervalLoadInfo);
                    intervalLoadInfo = undefined;
                }
            });

            /* Foto */
            /* $scope.selectImage = function (flowFile) {
                 var fileReader = new FileReader();
                 fileReader.onload = function (event) {
                     var uri = event.target.result;
                     $scope.$apply(function () {
                         $scope.event.icon = uri;
                         if (angular.isUndefined($scope.event.FK_events_images) || $scope.event.FK_events_images == null) $scope.event.FK_events_images = {};
                         $scope.event.FK_events_images.image = uri;
                         $scope.event.image_id = null; //Reseteamo el id para que pille la imagen.
                     });
                 };
                 fileReader.readAsDataURL(flowFile.file);
             };
 
             */

            $scope.selectImage = function () {
                $("#frmImage").trigger("click");
                $("#frmImage").change(function () {
                    var fileInput = document.querySelector('#frmImage') as HTMLInputElement;
                    var file = fileInput?.files?.[0];
                    if (file) {
                        Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: "events" }).then(function (result) {
                            if (result.filter(e => e.type === file.type).length <= 0) {
                                var typeAllowed = result.map(o => o.type).join(', ');
                                modalService.message({
                                    title: "Error",
                                    message: $filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                                    onAccept: function () { }
                                });
                            } else {
                                var maxSizeAllowed = result.find(e => e.type === file.type).maxsize;
                                var sizeFileMB = file.size / 1024;
                                if (sizeFileMB > 0) {
                                    //Comprobamos que no pase del tamaño limite de imagen
                                    if (sizeFileMB > maxSizeAllowed) {
                                        modalService.message({
                                            title: "Error",
                                            message: $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                            onAccept: function () { }
                                        });
                                    } else {
                                        var fileReader = new FileReader();
                                        fileReader.onload = function (event) {
                                            if (!event.target) return;
                                            var image = new Image();
                                            image.src = event.target.result as string;
                                            image.onload = function () {
                                                // access image size here 

                                                if (limit_image_height != 0 && limit_image_width != 0) {
                                                    //Comprobamos que no pase del tamaño limite de imagen
                                                    if (image.width > limit_image_width || image.height > limit_image_height) {
                                                        modalService.message({
                                                            title: "Error",
                                                            message: $filter('translate')('events.image_size_limit') + "<br>" + limit_image_width + "X" + limit_image_height,
                                                            onAccept: function () { }
                                                        });
                                                    } else {
                                                        if (angular.isUndefined($scope.event.FK_events_images) || $scope.event.FK_events_images == null) $scope.event.FK_events_images = {};
                                                        $scope.event.FK_events_images.image = image.src;
                                                        $scope.event.icon = image.src;
                                                        $scope.event.image_id = null; //??
                                                        $scope.event.changesNotSaved = true;
                                                        if (!$scope.$$phase) $scope.$apply()
                                                    }
                                                } else {
                                                    if (angular.isUndefined($scope.event.FK_events_images) || $scope.event.FK_events_images == null) $scope.event.FK_events_images = {};
                                                    $scope.event.FK_events_images.image = image.src;
                                                    $scope.event.icon = image.src;
                                                    $scope.event.image_id = null; //??
                                                    $scope.event.changesNotSaved = true;
                                                    if (!$scope.$$phase) $scope.$apply()
                                                }
                                            };
                                        };
                                        fileReader.readAsDataURL(file);
                                    }
                                } else {
                                    $scope.removeImage();
                                }
                            }
                        });
                    } else {
                        $scope.removeImage();
                    }
                });
            };

            $scope.getImage = function () {
                if ($scope.event.FK_events_images != null && $scope.event.FK_events_images.image != null) {
                    return $scope.event.FK_events_images.image;
                } else if ($scope.event.image_id != null) {
                    let widthContainer = $("#eventMenuContainer").width();
                    return "/api/Image/GetImageBmp?id=" + $scope.event.image_id + "&maxW=" + widthContainer + "&maxH2=150";
                } else {
                    return "assets/img/no_image_event.png";
                }
            };

            $scope.removeImage = function ($event) {
                $scope.event.image_id = null;
                if ($scope.event.FK_events_images != null) $scope.event.FK_events_images.image = null;
                $scope.event.icon = null;
                $scope.event.changesNotSaved = true;
            };

        }
    }])

    .controller("EventsEditCtrl", ['$http', 'event', 'LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', 'eventService', 'generateDocumentService', 'logService', '$timeout', '$q',
        function ($http, event, LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, eventService, generateDocumentService, logService, $timeout, $q) {

            $scope.isPageLoaded = false;

            //Comprobamos si tiene permiso escritura
            $scope.restricted_access = false;
            $scope.allowWrite = LoginService.permissionExist("EVENTS_WRITE");
            $scope.canManageEntityAcl = function (acl) {
                return LoginService.aclEnabled() && LoginService.permissionExist("ACL_MANAGE") && LoginService.userCanManageAcl(acl);
            };
            $scope.aclUsers = [];
            $scope.aclGroups = [];
            $scope.aclOptionsLoaded = false;
            $scope.aclDialogState = { visible: false, savedVersion: 0 };
            $scope.allowShowGuests = LoginService.permissionExist("EVENTS_GUESTS_READ");
            $rootScope.title = $filter('translate')('events.title');
            $rootScope.days = 0;
            $rootScope.company_id = LoginService.get("companyId");

            $scope.id = $stateParams.id;
            $scope.is_template = $stateParams.is_template == 'true';
            $scope.urlApi = (window as any).CONFIG.api_url;
            $scope.guests = {};
            $scope.location_id = null;
            $scope.isLocationSelected = false;
            $scope.locationAvailable = false;
            $scope.parent_allowed = true;
            $scope.event = [{}];
            $scope.event.differentZoneFrom = null;
            $scope.event.differentZoneTo = null;

            $scope.selectIdentificationTypes = [{ id: 'document', name: $filter("translate")('events.identification_document') }, { id: 'document_birthdate', name: $filter("translate")('events.identification_document_birthdate') }];

            $scope.timezones = moment.tz.names();
            $scope.onCheckIdentification = function (check) {
                if (check) {
                    $scope.event.identification_type = $scope.selectIdentificationTypes[0].id;
                } else {
                    $scope.event.identification_type = null;
                }
            }

            // Controlamos que no se pueda hacer que un padre sea hijo. 
            $scope.checkIfParentAllowed = function (item) {
                if (item && item.is_parent) {
                    $scope.parent_allowed = false;
                    $scope.event.parent_event_id = null;
                } else {
                    $scope.parent_allowed = true;
                };
            }

            //convierte un fecha en una zona horaria a la correspodiente local
            $scope.toTZDate = function(date, timezone){
                let tzOffset = moment.tz.zone(timezone).utcOffset(new Date(date).getTime());
                let localTzOffset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date(date).getTime());
                let localDate = moment.tz(date, timezone).add(localTzOffset, 'minutes').add(-tzOffset, 'minutes').toDate();
                return localDate;
            };

            //convierte un fecha en una zona horaria a la correspodiente local
            $scope.toLocalTZDate = function(date, timezone){
                let tzOffset = moment.tz.zone(timezone).utcOffset(new Date(date).getTime());
                let localTzOffset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date(date).getTime());
                let localDate = moment(date).add(-localTzOffset, 'minutes').add(tzOffset, 'minutes').toDate();
                return localDate;
            };

            //actualiza la cadena de tiempo local
            $scope.updateLocalTimeString = function(){
                if ($scope.event.timezone != null && $scope.event.timezone != moment.tz.guess()){
                    let dateFrom = moment($scope.toLocalTZDate($scope.event.date_from_tz, $scope.event.timezone)).format("DD/MM/YYYY HH:mm");
                    let dateTo = moment($scope.toLocalTZDate($scope.event.date_to_tz, $scope.event.timezone)).format("DD/MM/YYYY HH:mm");
                    $scope.event.differentZoneFrom = dateFrom + " (" + moment.tz.guess() + ")";
                    $scope.event.differentZoneTo = dateTo + " (" + moment.tz.guess() + ")";
                }else{
                    $scope.event.differentZoneFrom = '';
                    $scope.event.differentZoneTo = '';
                }
            };

            $scope.onDateFromChange = function(){
                $scope.updateLocalTimeString();
                $scope.filterParents();
            };
            $scope.onDateToChange = function(){
                $scope.updateLocalTimeString();
                $scope.filterParents();
            };

            $scope.onTimeZoneChange = function(){
                $scope.updateLocalTimeString();
            };

            //cargamos evento o creamos nuevo
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                $scope.$parent.mainDataEditable = true;
                $scope.$parent.mainDataVisible = true;
                // is_companions_allowed está al reves, cuando es true no permite acompañantes 
                // Metemos la configuración por defecto
                $scope.event = { information_groups_values: [], language_id: $rootScope.languageId, format: "presencial", all_day: true, is_companions_allowed: true };

                Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
                    $scope.event.require_invitation_confirmation = results.require_invitation_confirmation;
                    if (results.article_10 == true) { $scope.article10 = true; }
                    if (results.article_12 == true) { $scope.article12 = true; }
                    if (results.default_order_article == 'article10') {
                       $scope.event.radio_article_10 = "1";
                    } else {
                        $scope.event.radio_article_10 = "0";
                    }

                    //Cargamos por defecto la zona de la empresa
                    $scope.event.timezone = results.timezone;

                    if (results.public_guest_app_enabled == true) { $scope.public_guest_app_enabled = true; }
                    // cargamos el menu ahora para poder filtrar los items según los permisos
                    $scope.loadMenu();

                }); 


                // Ahora por defecto el evento es siempre todo el día

                if ($rootScope.newEvent!=null && !angular.isUndefined($rootScope.newEvent) && !angular.isUndefined($rootScope.newEvent.date) && $rootScope.newEvent.date!=null) {
                  //   $scope.event.all_day = true;
                    $scope.event.date_from_tz = $rootScope.newEvent.date;
                    $scope.event.date_to_tz = $rootScope.newEvent.date;
                } /*else {
                    $scope.event.all_day = true;
                }
                */
                $rootScope.newEvent = null;
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('events.title'), url: "events.list" },
                    { title: $filter('translate')('events.title_add')}
                ];
                $scope.restricted_access = false;

                // Cargamos igualemnte los infromation groups a petición de Rodolfo
                var options = { entity_type: "events" };
                Restangular.all('InformationsGroups').getList(options).then(function (informationGroups) {
                    $scope.informationGroups = informationGroups;
                    $scope.search.location = event.location;
                    $scope.informationGroups.forEach(function (pig) {
                        if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                    });
                    $scope.checkboxSimpleOptions = [
                        { option: null, label: $filter('translate')('informations.all'), checked: true },
                        { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
                        { option: false, label: $filter('translate')('events.staff.no'), checked: false }
                    ];
                });
                
            } else {

                $scope.is_template = event.is_template;

                $scope.event = event;
                

                //calculamos la hora correspondiente basada en la zona horario del evento
                $scope.event.date_from_tz = $scope.toTZDate($scope.event.date_from, $scope.event.timezone);
                $scope.event.date_to_tz = $scope.toTZDate($scope.event.date_to, $scope.event.timezone);
                $scope.updateLocalTimeString();

                if (!$scope.event.format) $scope.event.format = "presencial";

                if ($scope.event.event_type && $scope.event.event_type.is_parent) {
                    $scope.parent_allowed = false;
                }

                //BUSCAR
                //generamos lista de valores de persons informations groups
                $scope.event.pigs = [];

                var options = { entity_type: "events" };
                Restangular.all('InformationsGroups').getList(options).then(function (informationGroups) {
                    $scope.informationGroups = informationGroups;
                    $scope.search.location = event.location;

                    $scope.informationGroups.forEach(function (pig) {
                        if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                    });
                    $scope.checkboxSimpleOptions = [
                        { option: null, label: $filter('translate')('informations.all'), checked: true },
                        { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
                        { option: false, label: $filter('translate')('events.staff.no'), checked: false }
                    ];
                    //Lo recorremos para pintarlos correctamente.
                    angular.forEach($scope.event.information_groups_values, function (pig) {
                        var infoFilter = $scope.informationGroups.filter(function (el) { return el.id == pig.information_group_id; });
                        if (infoFilter[0].type == "checkboxSimple") {
                            $scope.event.pigs[pig.information_group_id] = pig.value; //(pig.value == "true" || pig.value == true ? true : false);
                        } if (infoFilter[0].type == "datetime") {
                            $scope.event.pigs[pig.information_group_id] = new Date(pig.value);
                        } else {
                            $scope.event.pigs[pig.information_group_id] = pig.value;
                        }
                    });
                });

                $rootScope.title = $scope.event.name;
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('events.title'), url: "events.list" },
                    { title: $scope.event.name + " - " + $filter('translate')('events.title_edit') }
                ];
                if ($scope.event.date_from != null) $scope.event.date_from = new Date($scope.event.date_from);
                if ($scope.event.date_to != null) $scope.event.date_to = new Date($scope.event.date_to);
                if ($scope.event.FK_events_users == null) $scope.event.FK_events_users = undefined;
                $scope.restricted_access = $scope.event.is_restricted_access && (LoginService.get("userId") != $scope.event.responsible_id);
            }

            $scope.saveEvent = function () {

                // Si el evento permite acompañantes, el número máximo de acompañantes tiene que ser menor que 0 
                if ($scope.event.is_companions_allowed == false && $scope.event.default_companions_limit < 1) {

                    return modalService.message({
                        title: $filter('translate')('events.min_companions_limit_exception_title'),
                        message: $filter('translate')('events.min_companions_limit_exception_message'),
                        onAccept: function () { }
                    });
                    // break;
                }

                if ($scope.search.location != null) {
                    if (typeof ($scope.search.location.term) != "undefined") {
                        $scope.event.location = $scope.search.location.term;
                        $scope.event.location_id = $scope.search.location.id;
                    } else {
                        $scope.event.location = $scope.search.location;
                        if ($scope.event.locationChanged) {
                            $scope.event.location_id = null;
                        }
                    }
                } else {
                    $scope.event.location = $scope.search.location;
                }

                $scope.event.is_template = $scope.is_template;
                if (angular.isDefined($scope.event.FK_events_users) && $scope.event.FK_events_users!=null) $scope.event.responsible_id = $scope.event.FK_events_users.id;
                if ($scope.event.date_to != null && $scope.event.date_to < $scope.event.date_from) $scope.event.date_to = $scope.event.date_from;

                // Aseguramos que la variable tenga valor
                if ($scope.event.pigs) {
                    angular.forEach($scope.informationGroups, function (pig) {
                        var value = $scope.event.pigs[pig.id];
                        var pips = $filter("filter")($scope.event.information_groups_values, { information_group_id: pig.id });
                        if (pips != null && pips.length > 0) {
                            var pip = pips[0];
                            pip.value = value;
                        } else {
                            var newPip = {
                                entity_type: "events",
                                entity_type_id: (angular.isDefined($stateParams.id) && $stateParams.id != "" ? $scope.event.id : null),
                                information_group_id: pig.id,
                                value: value
                            };
                            if (typeof (value) != "undefined") $scope.event.information_groups_values.push(newPip);
                        }
                    });
                    angular.forEach($scope.event.information_groups_values, function (pig) {
                        $scope.event.pigs[pig.information_group_id] = pig.value;
                    });
                }

                // Permisividad de acompañantes
                if ((typeof ($scope.event.is_companions_allowed) != "undefined") && (typeof ($scope.event.default_companions_limit) != "undefined")) {
                    if (typeof ($scope.event.is_companions_allowed) != "undefined" && $scope.event.is_companions_allowed == true) $scope.event.default_companions_limit = 0;
                    if ($scope.event.is_companions_allowed == false && typeof ($scope.event.default_companions_limit) != "undefined" && ($scope.event.default_companions_limit == 0 || $scope.event.default_companions_limit == "")) $scope.event.is_companions_allowed = true;
                } else {
                    // Si no se han informado los campos 'No permitir acompañantes' y 'Límite de acompañantes' se rellena su valor automáticamente
                    $scope.event.is_companions_allowed = true;
                    $scope.event.default_companions_limit = 1;
                }

                if ($scope.event.radio_article_10 == "1") {
                    $scope.event.article_10 = true;
                } else {
                    $scope.event.article_10 = false;
                }

                //convertimos la fecha a la zona correcta para que guarde el mismo offset dobre el utc en todas las fechas independiemente de la zona elegida
                $scope.event.date_from = $scope.toLocalTZDate($scope.event.date_from_tz, $scope.event.timezone);
                $scope.event.date_to = $scope.toLocalTZDate($scope.event.date_to_tz, $scope.event.timezone);

                if (angular.isDefined($stateParams.id) && $stateParams.id != "") {

                    $scope.event.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('events.edit_success'));
                            $state.go("events.edit", { id: result.id, is_template: $scope.is_template });
                            $scope.event.changesNotSaved = false;
                            $scope.event.locationChanged = false;
                            if ($scope.event.article_10 == true) {
                                $scope.event.radio_article_10 = "1";
                            } else {
                                $scope.event.radio_article_10 = "0";
                            }
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('Events').post($scope.event).then(function (result) {

                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('events.create_success'));
                            $state.go("events.edit", { id: result.id, is_template: $scope.is_template });
                            $scope.event.changesNotSaved = false;
                            $scope.event.locationChanged = false;
                            if ($scope.event.article_10 == true) {
                                $scope.event.radio_article_10 = "1";
                            } else {
                                $scope.event.radio_article_10 = "0";
                            }
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }

            }
            let loadDataCombos = function () {
                Restangular.all('Users').getList({ withoutImages: true }).then(function (users) {
                    $scope.selectUsers = users;
                    //Valor por defecto Responsable_id, si es nuevo evento
                    if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                        var defaultUserFilter = users.filter(function (u) { return u.id == parseInt(localStorage.getItem("userId")); });
                        if (defaultUserFilter != null && defaultUserFilter.length > 0) {
                            $scope.event.FK_events_users = defaultUserFilter[0];
                        }
                    }
                });

                Restangular.all('EventsTypes').getList().then(function (eventsTypes) {
                    $scope.selectEventsTypes = eventsTypes;
                });

                Restangular.all("Languages").getList({ use_for_events: true, active: true }).then(function (languages) {
                    $scope.availableLanguages = languages;
                });

                Restangular.all('EventHosts').getList().then(function (eventHosts) {
                    $scope.eventHosts = eventHosts;
                });

                Restangular.all("Events").customGET("AvailableParents").then(function (result) {
                    $scope.selectParents = result;
                    $scope.filterParents();
                });

            };

            // Filtramso los eventos que están dentro del rango 

            $scope.filterParents = function () {
                if ($scope.selectParents) {
                    $scope.selectParentsFiltered = $scope.selectParents.filter(e => e.date_from);
                    $scope.selectParentsFiltered = $scope.selectParentsFiltered.filter(e => new Date(e.date_to) > new Date($scope.event.date_to) && new Date(e.date_to) > new Date($scope.event.date_from));
                    $scope.selectParentsFiltered = $scope.selectParentsFiltered.filter(e => new Date(e.date_from) < new Date($scope.event.date_from) && new Date(e.date_from) < new Date($scope.event.date_to));
                    // Comprobamos si el evento padre puede seguir siendolo (Si el evento que editamso está dentro del rango de fechas)
                    if (!$scope.selectParentsFiltered.map(p => p.id).includes($scope.event.parent_event_id)) {
                        $scope.event.parent_event_id = null;
                    };
                }

            };

            loadDataCombos();

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('events.button_delete'),
                    message: $filter('translate')('events.delete_message') + " " + $scope.event.name + "?",
                    onAccept: function () {
                        Restangular.one('Events', $scope.event.id).remove({ send_notifications: $scope.event.send_notifications }).then(function () {
                            //$scope.event.remove().then(function () {
                            toastr.success($filter('translate')('events.delete_success'));
                            if ($scope.is_template) $state.go("events.list", { is_template: true });
                            else $state.go("events.list", { is_template: false });
                        });
                    }
                });
            };

            $scope.createTemplateFromEvent = function () {
                if (angular.isDefined($scope.event.id)) {
                    modalService.confirm({
                        title: $filter('translate')('events.button_create_template'),
                        message: $filter('translate')('events.button_create_template_message') + " " + $scope.event.name + "?",
                        onAccept: function () {
                            Restangular.all("Events/createTemplateFromEvent").post($scope.event).then(function (event) {
                                toastr.success($filter('translate')('events.created_template_from_event_success'));

                            });
                        }
                    });

                }
            }

            //set or unset as favourite event
            $scope.eventFavourite = function (event_id) {
                Restangular.all('EventsFavouriteUsers').customPOST({}, "SetOrUnsetFavourite", { event_id: event_id }).then(function (result) {
                    $scope.event.favourite_to_user = !$scope.event.favourite_to_user;
                });

            }

            $scope.search = {
                "location": null,
                locations: [],
                location_min_length: 3
            };

            $scope.getLocationsSearch = function (val) {
                if (val == null) {
                    val = '';
                } else {
                    val = val.replace(/[:.?*+^$[\\(){|]/, "");
                }
                let ret = [];

                /*if ($scope.search.location != null) {
                    angular.forEach($scope.search.location, function (row) {
                        if (row.term.includes(val)) {
                            ret.push(row);
                        }
                    });
                } else {*/
                ret = Restangular.all('search/locations/' + val).getList().then(function (searchTerms) {
                    return searchTerms;
                });
                //}
                return ret;
            };

            $scope.locationSelected = function ($item, $model, $label) {
                $scope.isLocationSelected = true;
                Restangular.all('Locations/' + $item.id + '/CheckAvailability').customGETLIST("",
                    { date_from: $scope.event.date_from, date_to: $scope.event.date_to})
                    .then(function (results) {
                        if(angular.isArray(results) && results.length > 0) {
                            $scope.locationAvailable = false;
                            $scope.event.reserve = false;
                        } else {
                            $scope.locationAvailable = true;
                        }
                    });
                $scope.search.position_min_length = 0;
                $scope.location_id = $item.id;
                Restangular.one('Locations', $item.id).get().then(function (results) {
                    if (results.name !== undefined && results.length > 0) {
                        $scope.search.locations = [];
                        angular.forEach(results, function (row) {
                            $scope.search.locations.push({
                                id: row.id, // Este es el position_id de cara a luego usarlo para buscar el correo
                                term: row.name
                            });
                        });

                    }
                });
            };


            $scope.printDialog = function (code, type_document, type_result, id) {
                var params = {
                    entity_type: "events",
                    entity_type_id: $stateParams.id,
                    documents: { codes: [code] }
                };
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            //url = (window as any).CONFIG.api_url + 'documentgenerator/' + item.document_url_method + '/' + item.document_id + '/' + params.entity_type_id + '/pdf';
                            //logService.debug(url);
                            //window.open(url, '_blank');
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, outputType: 'pdf', event_id: params.entity_type_id }
                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })
                    }
                });
            };

            $scope.duplicateEvent = function () {

                modalService.confirm({
                    title: $filter('translate')('events.duplicate_event'),
                    message: $filter('translate')('events.duplicate_events_message') + " " + $scope.event.name + "?",
                    onAccept: function () {
                        if ($scope.event.id != null) {
                            Restangular.all('Events').customPOST({}, $scope.event.id + "/duplicate", {}).then(function (result) {
                                if (angular.isDefined(result.id)) {
                                    toastr.success($filter('translate')('events.create_success'));
                                    $state.go("events.edit", { id: result.id, is_template: $scope.is_template });
                                } else {
                                    $scope.errorMessage = result.message;
                                }
                            });
                        }
                    }
                });

            }

            let normalizeAclUser = function (user) {
                const name = user.name || user.username || ('User #' + user.id);
                const username = user.username || '';
                const words = name.trim().split(/\s+/);
                const initials = (words.length >= 2 ? words[0][0] + words[words.length - 1][0] : name.slice(0, 2)).toUpperCase();
                return { id: user.id, label: name, initials: initials, sub: (username && username !== name) ? username : (user.email || '') };
            };

            let normalizeAclGroup = function (group) {
                const name = group.name || ('Group #' + group.id);
                return { id: group.id, label: name, initials: name.slice(0, 2).toUpperCase(), sub: group.members_count ? (group.members_count + ' miembros') : '' };
            };

            $scope.loadAclOptions = function () {
                if ($scope.aclOptionsLoaded) return $q.when();
                return $q.all([
                    Restangular.all('Users').getList(),
                    Restangular.all('UsersGroups').getList()
                ]).then(function (results) {
                    $scope.aclUsers = (results[0] || []).map(normalizeAclUser);
                    $scope.aclGroups = (results[1] || []).map(normalizeAclGroup);
                    $scope.aclOptionsLoaded = true;
                });
            };

            $scope.openAclDialog = function () {
                $scope.loadAclOptions().then(function () {
                    $scope.aclDialogState.visible = true;
                });
            };

            $scope.$watch('aclDialogState.savedVersion', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    $scope.event.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('events.acl_save_success'));
                        }
                    });
                }
            });

            $scope.$watchGroup(['event.name', 'event.radio_article_10', 'event.date_from.getUTCDate()', 'event.date_to.getUTCDate()',
                'event.FK_events_users', 'event.is_companions_allowed', 'event.default_companions_limit', 'event.all_day',
                'event.show_in_dashboard', 'event.event_finished', 'event.require_invitation_confirmation',
                'event.allow_request_invitation', 'event.is_restricted_access', 'event.hide_from_agenda_report', 'event.is_public', 'event.allow_parking','event.notes'], function (newVal, oldVal) {

                if (newVal === oldVal) {
                    $scope.event.changesNotSaved = false;
                    return;
                } else {
                    $scope.event.changesNotSaved = true;
                }
            }, true);
        }])

;
